module.exports = __webpack_public_path__ + "./Malik_11a0368b9ac4d9f3881740bfcc30beea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/Malik.jpg
// module id = 534
// module chunks = 0